import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsPrintQueueInsertParm } from "./wsPrintQueueInsertParm";
import { wsPrintQueueDeleteParm } from "./wsPrintQueueDeleteParm";
import { wsMTAOverrideToggleParm } from "./wsMTAOverrideToggleParm";
import { wsPrintQueuePrintParm } from "./wsPrintQueuePrintParm";

@Injectable()
export class DataService_express {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressDataGet(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "OneCardExpress/OneCardExpressDataGet";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueValidateAdd
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueValidateAdd(PersonID: number) {
		var postResult$ = new Subject();
		var url = "OneCardExpress/IDPrintQueueValidateAdd";

		var promise$ = this.httpclientService.post(url, PersonID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueAdd
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueAdd(parms: wsPrintQueueInsertParm) {
		var postResult$ = new Subject();
		var url = "OneCardExpress/IDPrintQueueAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueDelete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueDelete(parms: wsPrintQueueDeleteParm) {
		var postResult$ = new Subject();
		var url = "OneCardExpress/IDPrintQueueDelete";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressPopupDataAddGet
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressPopupDataAddGet(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "OneCardExpress/OneCardExpressPopupDataAddGet";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MTAOverrideToggle
	//
	//-----------------------------------------------------------------------------------------------------
	MTAOverrideToggle(parms: wsMTAOverrideToggleParm) {
		var postResult$ = new Subject();
		var url = "OneCardExpress/MTAOverrideToggle";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueuePrint
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueuePrint(parms: wsPrintQueuePrintParm) {
		var postResult$ = new Subject();
		var url = "OneCardExpress/IDPrintQueuePrint";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PublicTransitPreferenceSelect
	//
	//-----------------------------------------------------------------------------------------------------
	PublicTransitPreferenceSelect() {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/PublicTransitPreferenceSelect";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
